(() => {
  const initMenu = (root) => {
    root.querySelectorAll('[data-tigris-header]:not([data-tigris-ready])').forEach((header) => {
      header.dataset.tigrisReady = 'true';

      const toggle = header.querySelector('[data-tigris-menu-toggle]');
      const drawer = header.querySelector('[data-tigris-menu-drawer]');
      if (!toggle || !drawer) return;

      let returnFocus = null;
      let scrollPosition = 0;

      const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('tigris-menu-open');
        document.body.classList.remove('tigris-menu-open');
        document.body.style.removeProperty('--tigris-scroll-top');
        window.scrollTo({ top: scrollPosition, behavior: 'instant' });

        window.setTimeout(() => {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 360);

        if (returnFocus) returnFocus.focus({ preventScroll: true });
      };

      const open = () => {
        returnFocus = document.activeElement;
        scrollPosition = window.scrollY;
        document.body.style.setProperty('--tigris-scroll-top', `-${scrollPosition}px`);
        drawer.hidden = false;
        document.documentElement.classList.add('tigris-menu-open');
        document.body.classList.add('tigris-menu-open');
        window.requestAnimationFrame(() => drawer.classList.add('is-open'));
        toggle.setAttribute('aria-expanded', 'true');

        const firstLink = drawer.querySelector('a');
        if (firstLink) window.setTimeout(() => {
          if (drawer.classList.contains('is-open')) firstLink.focus({ preventScroll: true });
        }, 280);
      };

      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') close();
        else open();
      });

      drawer.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      });

      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') close();
      });

      header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') close();
      });
    });
  };

  const initReveal = (root) => {
    const elements = root.querySelectorAll('[data-tigris-reveal]:not([data-tigris-reveal-ready])');

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = window.TigrisSections.revealObserver || new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    window.TigrisSections.revealObserver = observer;
    elements.forEach((element) => {
      element.dataset.tigrisRevealReady = 'true';
      observer.observe(element);
    });
  };

  const initRecipeFilters = (root) => {
    root.querySelectorAll('[data-recipe-filter-root]:not([data-recipe-filter-ready])').forEach((filterRoot) => {
      filterRoot.dataset.recipeFilterReady = 'true';

      const buttons = [...filterRoot.querySelectorAll('[data-recipe-filter]')];
      const cards = [...filterRoot.querySelectorAll('[data-recipe-card]')];
      const emptyState = filterRoot.querySelector('[data-recipe-empty]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const selectedCategory = button.dataset.recipeFilter;
          let visibleCards = 0;

          buttons.forEach((currentButton) => {
            const isActive = currentButton === button;
            currentButton.classList.toggle('is-active', isActive);
            currentButton.setAttribute('aria-pressed', String(isActive));
          });

          cards.forEach((card) => {
            const isVisible = selectedCategory === 'all' || card.dataset.recipeCategory === selectedCategory;
            card.hidden = !isVisible;
            if (isVisible) visibleCards += 1;
          });

          if (emptyState) emptyState.hidden = visibleCards !== 0;
        });
      });
    });
  };

  const init = (root = document) => {
    initMenu(root);
    initReveal(root);
    initRecipeFilters(root);
  };

  if (!window.TigrisSections) {
    window.TigrisSections = { init, revealObserver: null };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }

  window.TigrisSections.init(document);
})();
